// removed by extract-text-webpack-plugin
module.exports = {"field":"_2abf08jFDa2Otefdb8MXC_","value":"I8T3yYATdRte0AumxImjC"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56d7e7f6","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./~/vue-components/activity-summary/components/custom-section/fields/field.less
// module id = gQxs
// module chunks = 1